module.exports = __webpack_public_path__ + "img/wild.e7dd51c8.png";